import { isProduction } from "fe-common/utils/envGetter";
export const openInDialogue = (sessionId: string, ragApp?: string) => {
  const url = `${
    isProduction()
      ? "https://dialogue.kahun.com/"
      : "https://dialogue-dev.kahun.com/"
  }${ragApp ? "app/" + ragApp + "/" : ""}${sessionId}`;
  window.open(url, "_blank");
};
